import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { LocalisationRepresentantAutocompleteService } from '../../services/localisation-representant-autocomplete.service';
import { FormattedLocalisation } from '../../modeles/formatted-localisation.modele';

@Component({
  selector: 'app-localisation-representant-autocomplete',
  templateUrl: './localisation-representant-autocomplete.component.html',
  styleUrls: ['./localisation-representant-autocomplete.component.scss'],
  standalone: false
})
export class LocalisationRepresentantAutocompleteComponent implements OnInit {
  @Input()
  parentForm: FormGroup;

  filteredLocalisations: Observable<FormattedLocalisation[]>;

  isFieldFocused = false;

  constructor(private readonly _autocompleteService: LocalisationRepresentantAutocompleteService) {}

  ngOnInit() {
    this.initAutocomplete();
  }

  formatLocalisationDisplay(localisation?: FormattedLocalisation) {
    return localisation ? localisation.description : undefined;
  }

  clearInput() {
    this.parentForm.get('localisationRepresentant').setValue(null);
    this.parentForm.updateValueAndValidity();
  }

  resetInputScroll(autocompleteInput) {
    // Not supported by IE/Opera
    if (autocompleteInput.scrollLeft) {
      autocompleteInput.scrollLeft = 0;
    }
  }

  get isClearButtonVisible() {
    return (
      this.parentForm.get('localisationRepresentant') &&
      this.parentForm.get('localisationRepresentant').value !== null &&
      this.parentForm.get('localisationRepresentant').value !== '' &&
      this.isFieldFocused
    );
  }

  private initAutocomplete() {
    this._autocompleteService.setFormControl(this.parentForm.get('localisationRepresentant'));
    this.filteredLocalisations = this._autocompleteService.filteredLocalisationsChanged$;
  }
}
